<template>
  <div class="container">
    <section>
      <b-field>
        <button style="margin: 5px" class="button" @click="checkedRows = []" :disabled="!checkedRows.length">
          <span>Clear checked</span>
        </button>
        <!-- <button style="margin: 5px" :disabled="!checkedRows.length" class="button is-success">Compare Selected</button> -->
        <button style="margin: 5px" disabled class="button is-success">Compare Selected</button>
      </b-field>
      <b-table :data="data" checkable :checked-rows.sync="checkedRows" striped hoverable>
        <template v-for="column in columns">
          <b-table-column :key="column.id" v-bind="column">
            <template v-if="column.searchable && !column.numeric" slot="searchable" slot-scope="props">
              <b-input v-model="props.filters[props.column.field]" placeholder="Search" />
            </template>
<template v-if="column.field === 'name'" v-slot="props">
              <router-link :to="`/blueprint/${props.row[column.field]}`">{{ props.row[column.field] }}</router-link>
            </template>
            <template v-else v-slot="props">
              {{ props.row[column.field] }}
            </template>
          </b-table-column>
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'Home',
    mounted() {
      fetch('https://craftingdb.decentralised.tech/api/bp-list').then(r => r.json()).then(data => this.data = data);
    },
    data() {
      return {
        checkedRows: [],
        data: [],
        columns: [{
            field: 'name',
            label: 'Name',
            searchable: true,
            sortable: true
          },
          {
            field: 'book',
            label: 'BP Book',
            searchable: true,
            sortable: true
          },
          {
            field: 'tt',
            label: 'Click TT',
            sortable: true,
            numeric: true
          },
          {
            field: 'skill',
            label: 'Skill',
            searchable: true,
            sortable: true
          },
          {
            field: 'skill_level',
            label: 'Skill Level',
            sortable: true,
            numeric: true
          }
        ]
      }
    }
  }
</script>